import {
    ButtonPrimary,
    ErrorFeedbackScreen,
    skinVars,
    SuccessFeedbackScreen,
    useWindowSize,
} from '@telefonica/mistica';
import { t } from 'i18next';
import { useNavigate } from 'react-router-dom';
import './index.scss';
import { useBillsContext } from '../../../../context/bills-context/BillsContext';

const BillsDownloadFeedback = () => {
    const navigate = useNavigate();
    const size = useWindowSize();
    const { isDownloadCompleted, downloadError } = useBillsContext();

    return (
        <div
            className='download-feedback'
            style={{
                background: isDownloadCompleted
                    ? size.width < 1024 || size.height < 550
                        ? skinVars.colors.backgroundBrand
                        : ''
                    : skinVars.colors.background,
            }}
        >
            {isDownloadCompleted && (
                <SuccessFeedbackScreen
                    title={t('downloadSuccessTitle')}
                    description={t('downloadSuccessDescription')}
                    primaryButton={
                        <ButtonPrimary onPress={() => navigate('/bills')}>{t('calldivertalerttextbtn')}</ButtonPrimary>
                    }
                />
            )}
            {!isDownloadCompleted && (
                <ErrorFeedbackScreen
                    title={t('downloadErrorTitle')}
                    description={t('downloadErrorDescription')}
                    errorReference={
                        downloadError?.response?.status
                            ? `${t('feedbackCodeError')} ${downloadError?.response?.status}`
                            : ''
                    }
                    primaryButton={
                        <ButtonPrimary onPress={() => navigate('/bills')}>{t('calldivertalerttextbtn')}</ButtonPrimary>
                    }
                />
            )}
        </div>
    );
};

export default BillsDownloadFeedback;
